import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AsmBindCartComponent, DotSpinnerComponent } from '@spartacus/asm/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';
import { SikoDialogService } from '@siko/shared/utils/siko-dialog.service';
import { SikoButtonComponent } from '@siko/components/atomic';
import { SikoUser } from '@siko/models/user.model';
import { SikoB2bUsersSalesNoteDialogComponent } from '@siko/features/asm/components/users-sales-note-dialog/users-sales-note-dialog.component';

@Component({
   selector: 'siko-b2b-asm-bind-cart',
   imports: [
      FormsModule,
      NgClass,
      ReactiveFormsModule,
      DotSpinnerComponent,
      AsyncPipe,
      TranslatePipe,
      SikoButtonComponent,
   ],
   templateUrl: './asm-bind-cart.component.html',
   styleUrl: './asm-bind-cart.component.scss',
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SikoB2bAsmBindCartComponent extends AsmBindCartComponent {

   readonly customer = input.required<SikoUser>();

   readonly usersSalesNote = computed(() => this.customer()?.orgUnit?.sikoSalesNote);

   readonly sikoDialogService = inject(SikoDialogService);

   onUsersSalesNote(): void {
      const modalRef = this.sikoDialogService.open(SikoB2bUsersSalesNoteDialogComponent, {
         windowClass: 'siko-dialog-window',
         size: 'md',
      });

      modalRef.componentInstance.salesNoteLines.set(this.usersSalesNote() ?? '');
   }
}
